<template>
    <transition name="drawer">
        <div id="help-center" v-if="open">
            <div class="drawer">
                <div class="drawer-content">
                    <div class="help-center">
                        <iframe :src="getHelpUrl()"></iframe>
                    </div>
                    <a :href="getHelpUrl()" class="help-center-button" target="_blank">
                        {{ trans('help.open_in_new_window') }}
                        <i class="zmdi zmdi-open-in-new"></i>
                    </a>
                </div>
            </div>
            <div class="drawer-overlay" @click="toggle"></div>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            open: false,
            customUrl: ''
        }
    },
    props: {
        url: {
            required: true
        },

        user: {
            required: true,
        },

        on_tour: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        toggle() {
            this.open = !this.open;
        },
        getHelpUrl() {
            if (this.customUrl) {
                return this.customUrl;
            }

            return this.mapHelpUrl();
        },

        mapHelpUrl() {
            let url = 'https://easypractice.net/help/';
            let home = 'introduction/';

            switch (this.user.language) {
                case "da":
                    url = 'https://terapeutbooking.dk/hjaelp/';
                    home = 'hjaelpecenter/';
                    break;
                case "no":
                    url = 'https://easypractice.net/nb/help/';
                    home = 'introduksjon/';
                    break;
                case "sv":
                    url = 'https://easypractice.net/sv/help/';
            }

            const routeMap = {
                "en": {
                    "calendar": "calendar",
                    "clients": "clients",
                    "client/": "clients",
                    "products": "services",
                    "invoices": "invoices",
                    "invoice": "invoices/adding-new-invoices",
                    "creditnote": "invoices/adding-new-invoices",
                    "giftcards": "gift-cards",
                    "online-courses/create": "online-courses/add-online-courses",
                    "online-courses/": "online-courses/view-online-course",
                    "online-courses": "online-courses",
                    "statistics": "statistics",
                    "easypay": "online-payments-easypay",
                    "settings/profile": "general-settings/your-profile",
                    "settings/messages": "general-settings/e-mail-sms",
                    "settings/subscription": "general-settings/your-subscription",
                    "settings/importExport": "general-settings/import-export",
                    "settings/invoice": "invoices",
                    "settings/calendar": "calendar",
                    "settings/surveys": "apps/surveys",
                    "settings/api/settings": "apps/api",
                    "settings/apps/booking-status/settings": "apps/calendar-apps",
                    "settings/apps/giftcards/settings": "apps/gift-cards",
                    "settings/apps/discount-codes/settings": "apps/discount-codes",
                    "settings/apps/online-booking/settings": "online-booking",
                    "settings/apps/waiting-list/settings": "apps/waiting-list",
                    "settings/apps/easypay/settings": "online-payments-easypay",
                    "settings/apps/online-meetings/settings": "apps/video-meetings",
                    "settings/apps/events/settings": "apps/events",
                    "settings/apps/journal/settings": "journals",
                    "settings/apps/custom-client-fields/settings": "apps/custom-fields",
                    "settings/apps/client-tags/settings": "apps/client-tags",
                    "settings/apps/messaging/settings": "apps/secure-messages",
                    "settings/apps/reports/settings": "invoices/revenue-report",
                    "settings/apps/consent/settings": "apps/consent",
                    "settings/apps/g-analytics/settings": "apps/google-analytics",
                    "settings/apps": "apps",
                    "settings": "general-settings",
                    "usermanagement/settings": "apps/employees",
                },
                "da": {
                    "calendar": "kalender",
                    "clients": "klienter",
                    "client/": "klienter",
                    "products": "ydelser",
                    "invoices": "faktura",
                    "invoice": "faktura/tilfoej-nye-faktura",
                    "creditnote": "faktura/tilfoej-nye-faktura",
                    "giftcards": "gavekort",
                    "online-courses/create": "online-kurser/add-online-courses",
                    "online-courses/": "online-kurser/faa-indsigt-i-hvad-dine-klienter-ser-naar-de-tager-dit-kursus",
                    "online-courses": "online-kurser",
                    "statistics": home,
                    "easypay": "online-betaling-easypay",
                    "settings/profile": "generelle-indstillinger/din-profil",
                    "settings/messages": "generelle-indstillinger/e-mail-sms",
                    "settings/subscription": "generelle-indstillinger/dit-abonnement",
                    "settings/importExport": "generelle-indstillinger/import-eksport",
                    "settings/invoice": "faktura",
                    "settings/calendar": "kalender",
                    "settings/surveys": "apps/spoergeskemaer",
                    "settings/api/settings": "apps/api",
                    "settings/apps/booking-status/settings": home,
                    "settings/apps/giftcards/settings": "apps/gavekort",
                    "settings/apps/discount-codes/settings": home,
                    "settings/apps/online-booking/settings": "online-booking",
                    "settings/apps/waiting-list/settings": "apps/ventelister",
                    "settings/apps/easypay/settings": "online-betaling-easypay",
                    "settings/apps/online-meetings/settings": "apps/videomoeder",
                    "settings/apps/events/settings": "apps/events",
                    "settings/apps/journal/settings": "journaler",
                    "settings/apps/custom-client-fields/settings": "apps/ekstra-felter",
                    "settings/apps/client-tags/settings": home,
                    "settings/apps/messaging/settings": "apps/sikre-beskeder",
                    "settings/apps/reports/settings": "faktura/rapport-over-omsaetning",
                    "settings/apps/consent/settings": "apps/samtykke",
                    "settings/apps/g-analytics/settings": "apps/google-analytics-4",
                    "settings/apps": "apps",
                    "settings": "generelle-indstillinger",
                    "usermanagement/settings": "apps/medarbejdere",
                },
                "no": {
                    "calendar": "kalender",
                    "clients": "klienter",
                    "client/": "klienter",
                    "products": "services",
                    "invoices": "fakturaer",
                    "invoice": "fakturaer/opprett-nye-fakturaer",
                    "creditnote": "fakturaer/opprett-nye-fakturaer",
                    "giftcards": "apper/gavekort",
                    "online-courses/create": "apper/online-kurs/legg-til-online-kurs",
                    "online-courses/": "apper/online-kurs/se-ditt-online-kurs",
                    "online-courses": "apper/online-kurs",
                    "statistics": "statistikk",
                    "easypay": "online-betalinger-easypay",
                    "settings/profile": "generelle-innstillinger/din-profil",
                    "settings/messages": "generelle-innstillinger/e-post-sms",
                    "settings/subscription": "generelle-innstillinger/ditt-abonnement",
                    "settings/importExport": "generelle-innstillinger/import-eksport",
                    "settings/invoice": "fakturaer",
                    "settings/calendar": "kalender",
                    "settings/surveys": "apper/sporreskjema",
                    "settings/api/settings": "apper/api",
                    "settings/apps/booking-status/settings": "apper/avtalestatus",
                    "settings/apps/giftcards/settings": "apper/gavekort",
                    "settings/apps/discount-codes/settings": "apper/rabattkoder",
                    "settings/apps/online-booking/settings": "online-booking",
                    "settings/apps/waiting-list/settings": "apper/ventelister",
                    "settings/apps/easypay/settings": "online-betalinger-easypay",
                    "settings/apps/online-meetings/settings": "apper/videomoter",
                    "settings/apps/events/settings": "apper/arrangementer",
                    "settings/apps/journal/settings": "journaler",
                    "settings/apps/custom-client-fields/settings": "apper/ekstra-felt-2",
                    "settings/apps/client-tags/settings": "apper/klient-tags",
                    "settings/apps/messaging/settings": "apper/sikre-meldinger",
                    "settings/apps/reports/settings": "fakturaer/rapport-over-alle-inntekter",
                    "settings/apps/consent/settings": "apper/samtykke",
                    "settings/apps/g-analytics/settings": "apper/google-analytics",
                    "settings/apps": "apper",
                    "settings": "generelle-innstillinger",
                    "usermanagement/settings": "apper/ansatte",
                },
                "sv": {
                    "calendar": "kalender",
                    "clients": "klienter",
                    "client/": "klienter",
                    "products": "tjanster",
                    "invoices": "fakturor",
                    "invoice": "fakturor/skapa-ny-faktura",
                    "creditnote": "fakturor/skapa-ny-faktura",
                    "giftcards": "appar/gift-cards",
                    "online-courses/create": "appar/online-kurser/add-online-courses",
                    "online-courses/": "appar/online-kurser/view-online-course",
                    "online-courses": "appar/online-kurser",
                    "statistics": "statistics",
                    "easypay": "onlinebetalningar-easypay",
                    "settings/profile": "general-settings/your-profile",
                    "settings/messages": "general-settings/e-mail-sms",
                    "settings/subscription": "general-settings/your-subscription",
                    "settings/importExport": "general-settings/import-export",
                    "settings/invoice": "fakturor",
                    "settings/calendar": "kalender",
                    "settings/surveys": "appar/surveys",
                    "settings/api/settings": "appar/api",
                    "settings/apps/booking-status/settings": "appar/calendar-apps",
                    "settings/apps/giftcards/settings": "appar/gift-cards",
                    "settings/apps/discount-codes/settings": "appar/discount-codes",
                    "settings/apps/online-booking/settings": "online-booking",
                    "settings/apps/waiting-list/settings": "appar/waiting-list",
                    "settings/apps/easypay/settings": "onlinebetalningar-easypay",
                    "settings/apps/online-meetings/settings": "appar/video-meetings",
                    "settings/apps/events/settings": "appar/events",
                    "settings/apps/journal/settings": "journaler",
                    "settings/apps/custom-client-fields/settings": "appar/custom-fields",
                    "settings/apps/client-tags/settings": "appar/client-tags",
                    "settings/apps/messaging/settings": "appar/secure-messages",
                    "settings/apps/reports/settings": "fakturor/rapport-over-alla-intakter-2",
                    "settings/apps/consent/settings": "appar/consent",
                    "settings/apps/g-analytics/settings": "appar/google-analytics",
                    "settings/apps": "appar",
                    "settings": "general-settings",
                    "usermanagement/settings": "appar/employees",
                }
            }

            const keys = Object.keys(routeMap[this.user.language]);

            for (let i = 0; i < keys.length; i++) {
                if (this.url.includes('app/' + keys[i])) {
                    return url + routeMap[this.user.language][keys[i]] + '/' + '?source=' + this.$store.state.brand;
                }
            }

            return url + home;
        },
    },
    mounted() {
        window.addEventListener('openHelpCenter', (event) => {
            this.open = true;
            if ('url' in event.detail) {
                this.customUrl = event.detail.url;
            }
        });

        $('.navHelpCentreButton').on('click', function (e) {
            e.preventDefault();
            window.dispatchEvent(new CustomEvent("openHelpCenter"));
        });
    }
}
</script>

<style scoped lang="scss">
// Drawer transition
.drawer-enter-active,
.drawer-leave-active {
    transition: all 0.3s ease;
    
    .drawer {
        transition: transform 0.3s ease;
    }
    
    .drawer-overlay {
        transition: opacity 0.3s ease;
    }
}

.drawer-enter-from,
.drawer-leave-to {
    .drawer {
        transform: translateX(100%);
    }
    
    .drawer-overlay {
        opacity: 0;
    }
}

.drawer {
    position: fixed;
    top: 0;
    right: 0;
    background-color: white;
    z-index: 1001;
}

.drawer-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: grey;
    opacity: 0.5;
    z-index: 1000;
}
</style>